import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandsDataServiceProvider } from '@services/brands/brands.data.service';
import { Subject } from 'rxjs';
import { BrandCreationData } from '@models/brands.model';
import { finalize, takeUntil } from 'rxjs/operators';
import { AccountServiceWebProvider } from '@web-services/user/account.service';

@Component({
	selector: 'reject-import-modal',
	template: require('./reject-import-modal.html'),
	styles: [require('./reject-import-modal.scss')]
})
export class RejectImportModalComponent {
	@Input() newBrandData: BrandCreationData;

	btnDisable = false;
	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private activeModal: NgbActiveModal,
		private accountService: AccountServiceWebProvider,
		private brandsDataService: BrandsDataServiceProvider
	) {}

	closeModal(): void {
		this.activeModal.close();
	}

	saveAndClose(): void {
		this.btnDisable = true;
		this.accountService
			.saveBrand(this.newBrandData)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize(() => (this.btnDisable = false))
			)
			.subscribe((res): void => {
				this.brandsDataService
					.updateBrands()
					.pipe(
						takeUntil(this.unsubscribe),
						finalize((): boolean => (this.btnDisable = false))
					)
					.subscribe(() => {
						this.activeModal.close(res);
					});
			});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/brands/modals/reject-import-modal/reject-import-modal.ts